import { useEffect, useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { BRAND_COLORS, STATUS_COLORS } from "../lib/bookingStatus";

/**
 * `CollapsibleSection` — Feb 2026 · Weissblom-weiter Akkordeon-Helper.
 * Klappt sich automatisch ein, sobald `allDone === true` (User hat ALLE
 * Punkte abgehakt → Status GRÜN); nach einem manuellen Klick gewinnt die
 * User-Entscheidung, damit man auch abgeschlossene Listen bewusst prüfen
 * kann. Wenn eine Zeile später wieder de-aktiviert wird und `allDone`
 * false wird, öffnet sich die Sektion automatisch wieder.
 *
 * Verwendung im Admin (TeamCustomerDetail) UND in der Kunden-App
 * (CustomerRequests) für einheitliche UX zwischen den beiden Rollen.
 *
 * Visuell:
 * • Header = klickbare Zeile mit Titel · optionalem grünen Haken · Chevron
 * • Chevron rotiert 90° wenn geschlossen (Signal "aufklappbar")
 * • Content unter dem Header wird nur gerendert wenn `isOpen === true`
 */
export function CollapsibleSection({
  title,
  subtitle,
  allDone = false,
  count,
  headerRight,
  children,
  testid,
  defaultOpen,
}) {
  const [manualOverride, setManualOverride] = useState(null);
  const isOpen = manualOverride === null
    ? (defaultOpen ?? !allDone)
    : manualOverride;
  useEffect(() => { if (!allDone) setManualOverride(null); }, [allDone]);
  const toggle = () => setManualOverride(!isOpen);
  return (
    <div data-testid={testid} data-collapsed={isOpen ? "false" : "true"} data-all-done={allDone ? "true" : "false"}>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={isOpen}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="w-full flex items-center gap-3 text-left group"
      >
        {allDone && (
          <span
            className="w-5 h-5 rounded-full flex items-center justify-center shrink-0"
            style={{ background: STATUS_COLORS.green }}
            aria-hidden
          >
            <Check className="w-3 h-3" style={{ color: BRAND_COLORS.ivory }} strokeWidth={3} />
          </span>
        )}
        <div className="flex-1 min-w-0">
          {title}
          {subtitle && <div className="text-[12.5px] text-navy-dark/60 mt-0.5">{subtitle}</div>}
        </div>
        {typeof count === "string" && (
          <span className="label-caps text-navy-dark/60 shrink-0">{count}</span>
        )}
        {headerRight}
        <ChevronDown
          className={`w-4 h-4 shrink-0 transition-transform text-navy-dark/50 group-hover:text-navy ${isOpen ? "" : "-rotate-90"}`}
          strokeWidth={2}
        />
      </button>
      {isOpen && <div className="mt-4">{children}</div>}
    </div>
  );
}

export default CollapsibleSection;
